import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { TbBarcodeOff } from "react-icons/tb";
import { FaBarcode } from "react-icons/fa";
import { MdOutlineManageHistory } from "react-icons/md";
import { BiBarcodeReader } from "react-icons/bi";
import { Modal } from 'bootstrap';
import { jsPDF } from "jspdf";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip'
import "jspdf-autotable"; // For table generation in PDF


export default function BarcodeGenerator() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const location = useLocation();
    const { id, subjectId, examname, subjectname } = location.state || {};
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [withBarcos, setWithBarcos] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [clearSelectedRows, setClearSelectedRows] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [barcodeCount, setBarcodeCount] = useState('');
    const modalRef = useRef(); // Reference for the modal
    const [extraBarcode, setExtrabarcode] = useState([]);
    const [loadingBarcodeNo, setLoadingBarcodeNo] = useState(null);
    const [facultyData, setFacultyData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [count, setCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [students, setStudents] = useState([]);
    const ClientName = localStorage.getItem('ClientName')
    const [punishmentData, setPunishmentData] = useState(null);
    const [reason, setReason] = useState('');
    const [negativeMarks, setNegativeMarks] = useState('');


    useEffect(() => {
        const role = localStorage.getItem('role');
        if (role !== 'ADMIN') {
            navigate("/");
        }
    }, [navigate]);
    useEffect(() => {
        fetchRecordswithbarcode();
    }, []); // eslint-disable-next-line 


    const fetchRecordswithbarcode = async () => {
        setLoading(true);
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${apiUrl}/api/students/with-barcode`, {
                headers: {
                    'Authorization': token
                },
                params: {
                    examId: id,
                    subjectId: subjectId // Include examId in the request parameters
                }
            });
            const { students } = response.data; // Destructure the response data
            setWithBarcos(students);
            setLoading(false);
            setStudents(response.data.students || []);
            setCount(response.data.totalStudents);


        } catch (error) {
            console.error('Error fetching records:', error);
            error.response?.status === 401 && navigate('/');

            setLoading(false);
        }
    };
    const withBarcodeColumns = [
        {
            name: "No",
            selector: (row, index) => {
                // Calculate serial number based on current page and rows per page
                return (currentPage - 1) * rowsPerPage + index + 1;
            },
            width: '50px',
             center: 'true',
        },
        {
            name: 'Barcode',
            width: '150px',
            center: "true",
            cell: (row) => (
                <div className=" fs-2 mb-2 " id="table-btn ">
                    <FaBarcode />
                </div>
            )
        },

        {
            name: "Roll Number",
            selector: (row) => row.rollNumber,
            sortable: true,
            width: '118px',
            center: 'true',
        },

        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },

        {
            name: 'Barcode Number',
            selector: (row) => row.barcodeNo,
            sortable: true,
            center: "true",

        },
        {
            name: 'Actions',
            selector: (row) => row.barcodeNo,
            sortable: true,
            center: "true",
            width: "210px",
            cell: (row) => (
                <div>
                    <button
                        data-tooltip-id="my-tooltip" data-tooltip-content=" Copy Case UFM  "
                        onClick={() => handleButtonClick(row.barcodeNo)}
                        className={`btn btn-sm mx-2 ${row.isCopyCase ? 'btn-secondary' : 'btn-primary'
                            }`}
                        disabled={loadingBarcodeNo === row.barcodeNo}
                    >
                        {loadingBarcodeNo === row.barcodeNo ? '...' : 'UFM'}
                    </button>
                    <button
                        data-tooltip-id="my-tooltip" data-tooltip-content=" Student Absent In Exam "
                        onClick={() => AbsentStudents(row)}
                        className={`btn btn-sm ${row.isAbsent ? 'btn-danger' : 'btn-primary'}`}
                    >
                        <i className="bi bi-person-fill-slash"></i>
                    </button>


                    <button
                        data-tooltip-id="my-tooltip" data-tooltip-content=" Check Answersheet  "
                        onClick={() => facultyButtonClick(row.barcodeNo, row)}
                        data-bs-toggle="modal" data-bs-target="#facultyModal"
                        className="btn btn-primary btn-sm mx-2"
                    >
                        <i className="bi bi-journal-richtext"></i>
                    </button>

                    <button
                        data-tooltip-id="my-tooltip" data-tooltip-content=" Punishment Marks  "
                        onClick={() => punishmentButtonClick(row.barcodeNo, row)}
                        data-bs-toggle="modal" data-bs-target="#punishmentModal"
                        className={`btn btn-sm ${typeof row.negativeMarks === 'number' ? 'btn-danger' : 'btn-primary'}`}
                    >
                        <i className="bi bi-exclamation-diamond-fill"></i>
                    </button>

                </div>


            )
        }



    ];
    const conditionalRowStyles = [
        {
            when: row => row.isCopyCase,
            style: {
                color: 'red',

            },
        },
        {
            when: row => row.isAbsent,
            style: {
                color: 'red',
            }
        },
        {
            when: row => typeof row.negativeMarks === 'number',
            style: {
                color: 'red',
            }
        }
    ]; const facultyButtonClick = async (barcodeNo, row) => {
        setSelectedRow(row); // Store the entire row data in state

        try {
            const token = localStorage.getItem('token');
            let data = JSON.stringify({ "barcodeNo": barcodeNo });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${apiUrl}/api/qrCode/faculty/detail?allocationType=NORMAL`,
                headers: {
                    'Authorization': `${token}`, // Ensure token format is correct (e.g., Bearer token if required)
                    'Content-Type': 'application/json'
                },
                data: data
            };

            const response = await axios.request(config);
            setFacultyData(response.data); // Set API response data in state

        } catch (error) {
            console.error("Error fetching data:", error);
            error.response?.status === 401 && navigate('/');
        }
    };
    const handleImageClick = (facultyId) => {
        closemodel();

        // Encode the barcode in base64 using btoa
        const encodedBarcode = btoa(selectedRow.barcodeNo || "");

        // Navigate with the encoded barcode and other data in the state
        navigate("/ViewAnswerSheet", {
            state: {
                facultyId,
                id,
                subjectId,
                barcode: encodedBarcode, // Pass encoded barcode
                barcodeId: selectedRow.qrCodeId,
                allocationType: 'NORMAL',
                userType: "admin",
                StaTus: "COMPLETED"

            }
        });
    };

    // ------------------ close model after submit----------------------
    const closemodel = () => {
        const closeButton = document.querySelector('#facultyModal .btn-close');
        if (closeButton) {
            closeButton.click();

        }
    };

    const punishmentButtonClick = async (barcodeNo, row) => {

        try {
            const token = localStorage.getItem('token');
            const { qrCodeId } = row;

            const config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${apiUrl}/api/qrCode/punishment/${qrCodeId}`,
                headers: {
                    'Authorization': `${token}`
                },
            };

            const response = await axios.request(config);
            const data = response.data.studentPunishment;
            setPunishmentData(data);
            setReason(data?.reason);
            setNegativeMarks(data?.negativeMarks);

        } catch (error) {
            console.error("⚠️ Error fetching punishment data:", error);
            error.response?.status === 401 && navigate('/');
        }
    };

    const closePunishmentModal = () => {
        const closeBtn = document.querySelector('#punishmentModal .btn-close');
        if (closeBtn) closeBtn.click();

        // Optional: reset fields
        setReason('');
        setNegativeMarks('');
    };


    const handlePunishmentSubmit = async () => {
        try {
            const token = localStorage.getItem('token');

            const payload = {
                id: punishmentData.id, // assuming punishmentData has `id`
                reasonPunishment: reason,
                negativeMarks: parseInt(negativeMarks)
            };

            const response = await axios.post(`${apiUrl}/api/qrCode/students-punishment`, payload, {
                headers: {
                    'Authorization': `${token}`,
                    'Content-Type': 'application/json'
                }
            });

            closePunishmentModal();
            toast.success(response.data.message);
            fetchRecordswithbarcode();

        } catch (error) {
            console.error("Error submitting punishment:", error);
            toast.error(error.response?.data?.message);
        }
    };




    const handleButtonClick = (barcodeNo) => {
        const isConfirmed = window.confirm(`Are you sure you want to proceed with barcode ${barcodeNo}?`);
        if (!isConfirmed) return;
        if (loadingBarcodeNo) return;
        setLoadingBarcodeNo(barcodeNo);
        const data = JSON.stringify({
            barcodeNo: barcodeNo,
            examId: id,
            subjectId: subjectId,
        });

        const token = localStorage.getItem('token');
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiUrl}/api/answersheet/copy-case`,
            headers: {
                'Authorization': `${token}`,
                'Content-Type': 'application/json',
            },
            data: data,
        };
        axios.request(config)
            .then((response) => {
                setLoadingBarcodeNo(null);
                fetchRecordswithbarcode();
                toast.success(response.data.message);
            })
            .catch((error) => {
                toast.error(error.response?.data?.message);
                setLoadingBarcodeNo(null);
                error.response?.status === 401 && navigate('/');
            });
    };


    const ExtraBarcode = async () => {
        const token = localStorage.getItem('token');
        const info = JSON.stringify({
            examId: id,
            subjectId: subjectId,
            count: parseInt(barcodeCount)  // Default to 2 if input is empty
        });

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiUrl}/api/emergencyBarcode`,
            headers: {
                'Authorization': `${token}`,
                'Content-Type': 'application/json'
            },
            data: info
        };

        try {
            const response = await axios.request(config);
            setExtrabarcode(response.data);
            setBarcodeCount('');
            toast.success("Barcode generated successfully");

        } catch (error) {
            console.error('Error in ExtraBarcode:', error);
            toast.error(error.response.data.message);
            error.response?.status === 401 && navigate('/');

        }
    };

    const handleSendBarcodeNos = async () => {
        const token = localStorage.getItem('token');
        const barcodeNos = selectedRows.map(row => row.barcodeNo); // Extract barcodeNo from selected rows

        const config = {
            method: 'post',
            url: `${apiUrl}/api/qrCode/detail`,
            headers: {
                'Authorization': `${token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                barcodeNos: barcodeNos
            })
        };

        try {
            const response = await axios.request(config);

            setModalData(response.data);  // Set the modal data
            // Create a new Bootstrap Modal instance
            const modalElement = modalRef.current;
            const modalInstance = new Modal(modalElement); // Bootstrap modal initialization
            modalInstance.show();  // Show the modal
            toast.success("Barcodes sent successfully");
            setSelectedRows([]);
            setClearSelectedRows(!clearSelectedRows);
        } catch (error) {
            console.error('Error sending barcodes:', error);
            toast.error("Error sending barcodes");
            error.response?.status === 401 && navigate('/');
        }
    };

    // Function to generate a PDF containing barcodes with student details
    const handleDownloadPDF = (barcodes, examname) => {
        // Initialize jsPDF object with a specific page size
        const pdf = new jsPDF("landscape", "cm", [10, 2.5]); // Set page size to 10cm width x 2.5cm height

        // Helper function to truncate text to a specific length
        const truncateText = (text, maxLength) => {
            return text.length > maxLength ? text.substring(0, maxLength) + "" : text;
        };

        // Define maximum character length for display
        const maxLength = 25

        // Loop through the barcodes and add their details to the PDF
        barcodes.forEach((barcode, index) => {
            // Reset position for each barcode section
            let yPosition = 0.6; // Starting Y position with a margin
            const leftColumnX = 0.4; // X position for text

            // Set font for the text details
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(8);

            const labelWidth = 1.5; // Minimum width for labels in cm
            const padding = 0.0; // Optional padding between label and data

            // Add Roll No, Exam, Subject, and Sub Code with character count
            pdf.text(`Roll No:`, leftColumnX, yPosition);
            pdf.text(`${barcode.studentRollNumber}`, leftColumnX + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Exam:`, leftColumnX, yPosition); // Use 'examname' instead of 'examName'
            const truncatedExamName = truncateText(examname, maxLength);
            pdf.text(`${truncatedExamName} `, leftColumnX + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Subject:`, leftColumnX, yPosition);
            const subjectName = barcode.subjectName;
            const truncatedSubjectName = truncateText(subjectName, maxLength);
            pdf.text(`${truncatedSubjectName}`, leftColumnX + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Sub Code:`, leftColumnX, yPosition);
            pdf.text(`${barcode.subjectCode}`, leftColumnX + labelWidth + padding, yPosition);
            yPosition += 0.5;

            // Add Barcode image if available
            if (barcode.barcodeJson?.[0]?.barcodeImage) {
                const img = new Image();
                img.src = barcode.barcodeJson[0].barcodeImage;

                // Ensure the image has the correct base64 prefix
                if (img.src.startsWith("data:image/")) {
                    pdf.addImage(img, "PNG", 6, 0.3, 3.5, 1.5); // Adjust position and size (X, Y, Width, Height)
                } else {
                    console.error("Invalid base64 image format:", img.src);
                }
            }

            // Add the barcode number below the image, centered
            pdf.setFontSize(10);
            pdf.text(`${barcode.barcodeNo}`, 7.8, 2.1, { align: "center" });

            // Add a new page for the next barcode if not the last one
            if (index !== barcodes.length - 1) {
                pdf.addPage();
            }
        });

        // Save the generated PDF file
        pdf.save("barcodes.pdf");
    };


    const handleDownloadPDF4 = (barcodes, examname) => {
        const pdf = new jsPDF("portrait", "cm", [21, 29.7]); // A4 size in portrait (swap width and height)

        const truncateText = (text, maxLength) => {
            return text.length > maxLength ? text.substring(0, maxLength) + "" : text;
        };

        const maxLength = 25; // Max length for truncating text
        const columns = 2; // Two barcodes per row
        const rows = 8; // Eight rows per page
        const barcodeWidth = 9.5; // Width for each barcode section (cm)
        const barcodeHeight = 3; // Height for each barcode section (cm)
        const labelWidth = 1.5; // Minimum width for labels in cm
        const padding = 0.2; // Padding between label and data
        const marginTop = -2.4; // Margin to add to the top of the barcode image
        const columnGap = 1.4; // Gap between columns (in cm)
        const pageTopMargin = 1.5; // Top margin for the page (in cm)
        const rowGap = 0.5; // Gap between rows (in cm)

        let yPosition = pageTopMargin; // Start the y-position from the top margin

        barcodes.forEach((barcode, index) => {
            const column = index % columns; // Determine column (0 or 1)
            const row = Math.floor(index / columns) % rows; // Determine row (0 to 7)

            // Reset yPosition and add a new page when required
            if (index > 0 && row === 0 && column === 0) {
                pdf.addPage();
                yPosition = pageTopMargin; // Reset yPosition for the new page
            }

            let xPosition = column * (barcodeWidth + columnGap) + 0.4; // X position for text and barcode
            yPosition = pageTopMargin + (row * (barcodeHeight + rowGap)) + 0.6; // Y position for text and barcode

            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(8);

            pdf.text(`Roll No:`, xPosition, yPosition);
            pdf.text(`${barcode.studentRollNumber}`, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Exam:`, xPosition, yPosition);
            const truncatedExamName = truncateText(examname, maxLength);
            pdf.text(`${truncatedExamName} `, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Subject:`, xPosition, yPosition);
            const subjectName = barcode.subjectName;
            const truncatedSubjectName = truncateText(subjectName, maxLength);
            pdf.text(`${truncatedSubjectName}`, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Sub Code:`, xPosition, yPosition);
            pdf.text(`${barcode.subjectCode}`, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            if (barcode.barcodeJson?.[0]?.barcodeImage) {
                const img = new Image();
                img.src = barcode.barcodeJson[0].barcodeImage;

                if (img.src.startsWith("data:image/")) {
                    pdf.addImage(img, "PNG", xPosition + 6, yPosition + marginTop, 3.6, 1.9); // Adjust X, Y, Width, Height
                    yPosition += 1.5; // Move the y-position after placing the barcode image
                } else {
                    console.error("Invalid base64 image format:", img.src);
                }
            }

            pdf.setFontSize(10);
            pdf.text(`${barcode.barcodeNo}`, xPosition + 7.8, yPosition - 1.7, { align: "center" });
        });

        pdf.save("barcodes.pdf");
    };

    const ERDownloadPDF = (barcodes, examname) => {
        // Initialize jsPDF object with a specific page size
        const pdf = new jsPDF("landscape", "cm", [10, 2.5]); // Set page size to 10cm width x 2.5cm height

        // Loop through the barcodes and add their details to the PDF
        barcodes.forEach((barcode, index) => {
            // Reset position for each barcode section
            let yPosition = 0.6; // Starting Y position with a margin
            const leftColumnX = 0.4; // X position for text

            // Set font for the text details
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(8);

            const labelWidth = 1.5; // Minimum width for labels in cm
            const padding = 0.0; // Optional padding between label and data

            // Add Roll No, Exam, Subject, and Sub Code
            pdf.text(`Roll No:`, leftColumnX, yPosition);
            pdf.text(`${""}`, leftColumnX + labelWidth + padding, yPosition); // Placeholder for roll number
            yPosition += 0.5;
            pdf.text(`Exam:`, leftColumnX, yPosition); // Use 'examname' instead of 'examName'
            pdf.text(`${examname}`, leftColumnX + labelWidth + padding, yPosition); // Place data after label
            yPosition += 0.5;
            pdf.text(`Subject:`, leftColumnX, yPosition);
            pdf.text(`${barcode.barcodeJson.subjectName}`, leftColumnX + labelWidth + padding, yPosition); // Place data after label
            yPosition += 0.5;
            pdf.text(`Sub Code:`, leftColumnX, yPosition);
            pdf.text(`${barcode.barcodeJson.subjectCode}`, leftColumnX + labelWidth + padding, yPosition); // Place data after label
            yPosition += 0.5;

            // Add Barcode image if available
            if (barcode.barcodeJson.barcodeImage) {
                const base64Image = barcode.barcodeJson.barcodeImage;

                // Ensure the image has the correct base64 prefix
                if (base64Image.startsWith("data:image/")) {
                    pdf.addImage(base64Image, "PNG", 6, 0.3, 3.5, 1.5); // Adjust position and size (X, Y, Width, Height)
                } else {
                    console.error("Invalid base64 image format:", base64Image);
                }
            }

            // Add the barcode number below the image, centered
            pdf.setFontSize(10);
            pdf.text(`${barcode.barcodeNo}`, 7.8, 2.1, { align: "center" });

            // Add a new page for the next barcode if not the last one
            if (index !== barcodes.length - 1) {
                pdf.addPage();
            }
        });

        // Save the generated PDF file
        pdf.save("barcodes.pdf");
    };

    const ERDownloadPDFA4 = (barcodes, examname) => {
        const pdf = new jsPDF("portrait", "cm", [21, 29.7]); // A4 size in portrait mode

        const truncateText = (text, maxLength) => {
            return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
        };

        const maxLength = 25; // Max length for truncating text
        const columns = 2; // Two barcodes per row
        const rows = 8; // Eight rows per page
        const barcodeWidth = 9.5; // Width for each barcode section (cm)
        const barcodeHeight = 3; // Height for each barcode section (cm)
        const labelWidth = 1.5; // Minimum width for labels in cm
        const padding = 0.2; // Padding between label and data
        const marginTop = -2.4; // Margin to add to the top of the barcode image
        const columnGap = 1.4; // Gap between columns (in cm)
        const pageTopMargin = 1.5; // Top margin for the page (in cm)
        const rowGap = 0.5; // Gap between rows (in cm)

        let yPosition = pageTopMargin; // Start the y-position from the top margin

        barcodes.forEach((barcode, index) => {
            const column = index % columns; // Determine column (0 or 1)
            const row = Math.floor(index / columns) % rows; // Determine row (0 to 7)

            // Reset yPosition and add a new page when required
            if (index > 0 && row === 0 && column === 0) {
                pdf.addPage();
                yPosition = pageTopMargin; // Reset yPosition for the new page
            }

            let xPosition = column * (barcodeWidth + columnGap) + 0.4; // X position for text and barcode
            yPosition = pageTopMargin + (row * (barcodeHeight + rowGap)) + 0.6; // Y position for text and barcode

            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(8);

            // Add Roll No, Exam, Subject, and Sub Code
            pdf.text(`Roll No:`, xPosition, yPosition);
            pdf.text(`${barcode.studentRollNumber || ""}`, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Exam:`, xPosition, yPosition);
            const truncatedExamName = truncateText(examname, maxLength);
            pdf.text(`${truncatedExamName}`, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Subject:`, xPosition, yPosition);
            const subjectName = barcode.barcodeJson?.subjectName || "";
            const truncatedSubjectName = truncateText(subjectName, maxLength);
            pdf.text(`${truncatedSubjectName}`, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            pdf.text(`Sub Code:`, xPosition, yPosition);
            pdf.text(`${barcode.barcodeJson.subjectCode || ""}`, xPosition + labelWidth + padding, yPosition);
            yPosition += 0.5;

            // Add Barcode image if available
            if (barcode.barcodeJson?.barcodeImage) {
                const base64Image = barcode.barcodeJson.barcodeImage;

                if (base64Image.startsWith("data:image/")) {
                    pdf.addImage(base64Image, "PNG", xPosition + 6, yPosition + marginTop, 3.6, 1.9); // Adjust X, Y, Width, Height
                    yPosition += 1.5; // Move the y-position after placing the barcode image
                } else {
                    console.error("Invalid base64 image format:", base64Image);
                }
            }

            // Add the barcode number below the image, centered
            pdf.setFontSize(10);
            pdf.text(`${barcode.barcodeNo || ""}`, xPosition + 7.8, yPosition - 1.7, { align: "center" });
        });

        pdf.save("barcodes_a4_format.pdf");
    };

    const AbsentStudents = (row) => {
        // Show confirmation prompt before proceeding
        const isConfirmed = window.confirm("Are you sure you want to mark this student as absent?");

        // If the user cancels, return early
        if (!isConfirmed) {
            return;
        }

        // If confirmed, proceed with the API request
        const data = JSON.stringify({
            examId: id,
            barcodeNo: row.barcodeNo,
        });

        const token = localStorage.getItem('token');

        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${apiUrl}/api/qrCode/absent-students`,
            headers: {
                Authorization: token, // Replace with your actual token
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios
            .request(config)
            .then((response) => {
                fetchRecordswithbarcode();  // Refresh the records
                toast.success(response.data.message);  // Show success message
            })
            .catch((error) => {
                toast.error(error.response.data.message);  // Show error message
                error.response?.status === 401 && navigate('/');  // Redirect to login if unauthorized
            });
    };

    const handleGeneratePDF = () => {
        const doc = new jsPDF({
            orientation: "portrait", // A3 in portrait mode
            unit: "mm",
            format: "a3",
        });

        const pageWidth = doc.internal.pageSize.width; // Get the width of the page
        const pageHeight = doc.internal.pageSize.height; // Get the height of the page

        const tableColumn = [
            "Barcode No",
            "Main sheet",
            "Extra (1)",
            "Extra (2)",
            "Extra (3)",
            "Extra (4)",
            "Student Sign"
        ];

        const tableRows = students.map(student => [
            student.barcodeNo,
            "", // Placeholder for "Main sheet"
            "", // Placeholder for "Extra (1)"
            "", // Placeholder for "Extra (2)"
            "", // Placeholder for "Extra (3)"
            "", // Placeholder for "Extra (4)"
            "", // Placeholder for "Student Sign"
        ]);

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 25, // Start position of the table
            theme: "grid",
            margin: { top: 25, bottom: 20, left: 5, right: 5 },
            styles: {
                fontSize: 10, // Default font size for body
                cellPadding: 3.5,
                fillColor: null, // No background color
                textColor: "black", // Text color is black
            },
            headStyles: {
                fillColor: null, // No background color in header
                textColor: "black", // Header text color is black
                fontSize: 15, // Font size for the header text
                halign: "center", // Center align the text in header columns
                lineWidth: 0.5, // Default line width for cells
                borderWidth: 2, // Border width for header cells
                borderColor: "black", // Border color for header cells
                lineColor: "black", // Border color for body cells
            },
            bodyStyles: {
                fillColor: null, // No background color in body
                textColor: "black", // Body text color is black
                fontSize: 12, // Font size for body text
                halign: "center", // Center align the text in body columns
                valign: "middle", // Vertical alignment to middle
                lineWidth: 0.5, // Border width for body cells
                lineColor: "black", // Border color for body cells
            },
            columnStyles: {
                0: { cellWidth: 40 }, // Adjust column width for "Barcode No"
            },
            pageBreak: "auto",
            rowPageBreak: "auto",
            didDrawPage: function (data) {
                // Text for every page
                const text = `${ClientName} Exam:-${examname}(${subjectname}) Attendance Sheet`;
                const textWidth = doc.getTextWidth(text); // Calculate the width of the text
                const xPosition = (pageWidth - textWidth) / 2; // Calculate the center position
                doc.text(text, xPosition, 15); // Place the text at the center horizontally

                // Footer - FS Sign (left side)
                doc.setTextColor(0, 0, 0); // Set text color to black
                const fsSignX = 10;
                const fsSignY = pageHeight - 10; // Position the FS sign near the bottom left
                doc.text("FS Sign", fsSignX, fsSignY);
                doc.line(fsSignX, fsSignY + 2, fsSignX + 50, fsSignY + 2); // Draw underline for FS Sign

                // Footer - GM Sign (right side)
                doc.setTextColor(0, 0, 0); // Set text color to black
                const gmSignX = pageWidth - 60;
                const gmSignY = pageHeight - 10; // Position the GM sign near the bottom right
                doc.text("GM Sign", gmSignX, gmSignY);
                doc.line(gmSignX, gmSignY + 2, gmSignX + 50, gmSignY + 2); // Draw underline for GM Sign
            }
        });

        // Save the document
        doc.save("Students_Attendance_Sheet.pdf");
    };

    return (
        <AdminLayout ac4='active'>
            <main id="main" className="main">
                <div className="pagetitle">
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item "> <Link to="/AdminHome">Dashboard</Link></li>
                            <li className="breadcrumb-item  cursor-pointer" onClick={() => navigate('/ListExam')}>View Exam</li>
                            <li className="breadcrumb-item cursor-pointer" onClick={() => navigate("/ExamDetails", { state: { id, subjectId, examname } })}>Exam Subjects</li>
                            <li className="breadcrumb-item active">With Barcode Student {subjectname} ({count})</li>
                        </ol>
                    </nav>
                </div>
                <hr className='mb-0' />
                <div className='row'>
                    <div className='container'>
                        <div className="datatable-top">
                            <div className="d-flex flex-row ">
                                <div className="">
                                    <div className="datatable-search">
                                        <input className="form-control" type="search" placeholder="Search" title="Search within table" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            <div className=" bd-highlight d-flex  col-sm-5">
                                <input
                                    className="form-control"
                                    type="number"
                                    placeholder="Emergency Barcode"
                                    value={barcodeCount}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={(e) => setBarcodeCount(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary ms-2 btn-sm"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content="Gnerate Emergency Barcode"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={ExtraBarcode}
                                >
                                    Emergency
                                </button>

                                <button type="button" className="btn btn-primary rounded-circle btn-sm ms-2 p-1 " onClick={() => navigate('/WithoutBarcode', { state: { id, subjectId, examname, subjectname } })}> <TbBarcodeOff className='barcode-nav-buuton' /></button>
                                <button type="button" className="btn border border-dark  rounded-circle btn-sm ms-2 p-1 " onClick={() => navigate('/WithBarcode', { state: { id, subjectId, examname, subjectname } })}> <BiBarcodeReader className='barcode-nav-buuton' /></button>
                                <button type="button" className="btn btn-primary rounded-circle btn-sm ms-2 p-1 " onClick={() => navigate('/EmergencyBarcode', { state: { id, subjectId, examname, subjectname } })}> <MdOutlineManageHistory className='barcode-nav-buuton' /></button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <DataTable
                                columns={withBarcodeColumns}
                                data={withBarcos.filter(record => {
                                    const nameMatches = record.name.toLowerCase().includes(searchTerm.toLowerCase());
                                    const rollNumberMatches = record.rollNumber
                                        .toString() // Convert rollNumber to string
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase());
                                    return nameMatches || rollNumberMatches;
                                })}
                                progressPending={loading}
                                pagination
                                selectableRows
                                onSelectedRowsChange={state => setSelectedRows(state.selectedRows)}
                                clearSelectedRows={clearSelectedRows}
                                className="custom-table"
                                conditionalRowStyles={conditionalRowStyles}
                                paginationPerPage={rowsPerPage} // Set rows per page
                                paginationTotalRows={withBarcos.length} // Total number of records
                                paginationDefaultPage={currentPage} // Default starting page
                                onChangePage={page => setCurrentPage(page)} // Update current page
                                onChangeRowsPerPage={newPerPage => setRowsPerPage(newPerPage)} // Update rows per page
                            />
                            <div className='d-flex justify-content-end mt-3'>
                                <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={handleGeneratePDF}
                                    data-tooltip-id="my-tooltip" data-tooltip-content=" Generate Student Attendance Sheet PDF"
                                >

                                    <i className="bi bi-filetype-pdf"></i>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary "
                                    onClick={handleSendBarcodeNos}
                                >
                                    <i className="bi bi-qr-code-scan"></i> Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
            {/* Modal for Generate Emergency Barcodes */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={modalRef}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header bg-secondary">
                            <h5 className="modal-title text-white p-1 rounded" id="exampleModalLabel">Generate Emergency Barcodes</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {extraBarcode.length > 0 ? (
                                extraBarcode.map((barcode, index) => (
                                    <div key={barcode.id || index} className="mb-3">
                                        <div className="container d-flex justify-content-center align-items-center ">
                                            <div className="border border-dark p-1 w-75">
                                                <div className="row">
                                                    <div className="col mt-2">

                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Roll No: </strong></div>
                                                            <div className=""><span ></span></div>
                                                        </div>
                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Exam: </strong></div>
                                                            <div className=""><span > {examname}</span></div>
                                                        </div>
                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Subject: </strong></div>
                                                            <div className=""><span > {barcode.barcodeJson.subjectName}</span></div>
                                                        </div>
                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Sub Code: </strong></div>
                                                            <div className=""><span > {barcode.barcodeJson.subjectCode}</span></div>
                                                        </div>
                                                    </div>
                                                    <div className="col text-end">
                                                        <div className="text-center">
                                                            <img src={barcode.barcodeJson.barcodeImage} alt={`Barcode ${index + 1}`} style={{ width: '250px', height: '100px', marginBottom: '-7px' }} />
                                                            <p className="mb-1 mt-0 "><strong className='text-danger'>{barcode.barcodeNo}</strong></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No barcodes generated yet.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-success mx-1"
                                onClick={() => ERDownloadPDF(extraBarcode, examname)} // This calls the function to generate the PDF
                            >
                                PDf 100 X 25
                            </button>
                            <button
                                type="button"
                                className="btn btn-success mx-1"
                                onClick={() => ERDownloadPDFA4(extraBarcode, examname)} // This calls the function to generate the PDF
                            >
                                A4 21 X 29.7
                            </button>

                            <button type="button" className="btn btn-secondary mx-1" data-bs-dismiss="modal" onClick={() => setExtrabarcode([])}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal for Regretted  Barcodes */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={modalRef}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header bg-secondary">
                            <h5 className="modal-title text-white p-1 rounded" id="exampleModalLabel">Regretted Barcodes</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {modalData.length > 0 ? (
                                modalData.map((barcode, index) => (
                                    <div key={barcode.id || index} className="mb-3">
                                        <div className="container d-flex justify-content-center align-items-center ">
                                            <div className="border border-dark p-1 w-75">
                                                <div className="row">
                                                    <div className="col mt-2">

                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Roll No: </strong></div>
                                                            <div className=""><span > {barcode.studentRollNumber}</span></div>
                                                        </div>
                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Exam: </strong></div>
                                                            <div className=""><span > {examname}</span></div>
                                                        </div>
                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Subject: </strong></div>
                                                            <div className=""><span > {barcode.subjectName}</span></div>
                                                        </div>
                                                        <div className="d-flex flex-row ">
                                                            <div className="barcode-labal"><strong>Sub Code: </strong></div>
                                                            <div className=""><span > {barcode.subjectCode}</span></div>
                                                        </div>
                                                    </div>
                                                    <div className="col text-end p-0">
                                                        <div className="text-center">
                                                            <img src={barcode.barcodeJson?.[0]?.barcodeImage} alt={`Barcode ${index + 1}`} style={{ width: '250px', height: '100px', marginBottom: '-7px' }} />
                                                            <p className="mb-1 mt-0"><strong>{barcode.barcodeNo}</strong></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No barcodes available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-success mx-1"
                                onClick={() => handleDownloadPDF(modalData, examname)} // This calls the function to generate the PDF
                            >
                                PDf 100 X 25
                            </button>
                            <button
                                type="button"
                                className="btn btn-success mx-1"
                                onClick={() => handleDownloadPDF4(modalData, examname)} // This calls the function to generate the PDF
                            >
                                A4 21 X 29.7
                            </button>
                            <button type="button" className="btn btn-secondary mx-1" data-bs-dismiss="modal" onClick={() => setModalData([])}>Close</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="facultyModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Faculty for {examname}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {facultyData.length > 0 ? (
                                <div className="container  ">
                                    <div className="row justify-content-center">
                                        {facultyData.map((faculty) => (
                                            <div
                                                key={faculty.id}
                                                className="col-4 d-flex flex-column align-items-center mb-3 p-2  "
                                                style={{ borderBottom: "1px solid #ddd" }}
                                            >
                                                <img
                                                    src="https://cdn-icons-png.freepik.com/512/16584/16584868.png?ga=GA1.1.1283962912.1697783763"
                                                    alt="Person Icon"
                                                    style={{ width: "50px", height: "50px", marginBottom: "8px", cursor: "pointer" }}
                                                    onClick={() => handleImageClick(faculty.id)} // Add onClick to navigate with faculty ID

                                                />
                                                <span className="text-primary fw-bold text-center" style={{ fontSize: "1em" }}>{faculty.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <p className="text-muted">No faculty data available.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="punishmentModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Punishment Marks</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {punishmentData ? (
                                <div>
                                    {/* <p><strong>Barcode:</strong> {punishmentData.barcodeNo}</p> */}

                                    <div className="mb-3">
                                        <label className="form-label"><strong>Reason</strong></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                            placeholder="Enter reason for punishment"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label"><strong>Negative Marks</strong></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={negativeMarks}
                                            onChange={(e) => setNegativeMarks(e.target.value)}
                                            placeholder="Enter negative marks"
                                        />
                                    </div>
                                    <small className="text-danger">
                                        * These marks will be directly deducted from the student's total marks.
                                    </small>
                                </div>
                            ) : (
                                <p>Loading punishment data...</p>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary" onClick={() => handlePunishmentSubmit()}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <Tooltip id="my-tooltip" />
            <ToastContainer position="top-center" style={{ width: "auto" }} />
        </AdminLayout>
    );
}